import { APIClient, getLoggedinUser } from "../helpers/api_helper";

const api = new APIClient();

const TENANT_LABOUR_RATE_BASE_URL = "/TenantLabourRate";

// Helper function to get tenantId from logged-in user
const getTenantId = (): string | null => {
    const authUser = getLoggedinUser();
    return authUser?.tenantId || null;
};

export interface TenantLabourRateItem {
    id: string;
    tenantId: string;
    tenantName?: string;
    scaffoldTaskType: number; // 1=Erect, 2=Modify, 3=Dismantle
    roleId: string;
    roleName?: string;
    ratePerHourPerStaff: number;
    effectiveFrom: string;
    effectiveTo?: string;
    isActive: boolean;
    notes: string;
    isDeleted: boolean;
    created?: string;
    modified?: string;
}

export interface TenantLabourRatePayload {
    tenantId?: string;
    scaffoldTaskType: number;
    roleId: string;
    ratePerHourPerStaff: number;
    effectiveFrom: string;
    effectiveTo?: string; // Made optional
    isActive: boolean;
    notes: string;
}

export interface TenantLabourRateResponse {
    items: TenantLabourRateItem[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export const getTenantLabourRates = (
    pageNumber: number = 1,
    pageSize: number = 50
) => {
    const tenantId = getTenantId();
    const queryParams: any = {
        pageNumber,
        pageSize,
        isActive: true
    };

    if (tenantId) {
        queryParams.tenantId = tenantId;
    }

    return api.get(TENANT_LABOUR_RATE_BASE_URL, queryParams);
};

export const getTenantLabourRateById = (id: string) => {
    return api.get(`${TENANT_LABOUR_RATE_BASE_URL}/${id}`, {});
};

export const createTenantLabourRate = (data: TenantLabourRatePayload) => {
    const tenantId = data.tenantId || getTenantId();
    if (!tenantId) {
        return Promise.reject(new Error("Organization ID is required"));
    }
    const payload = { ...data, tenantId };
    return api.create(TENANT_LABOUR_RATE_BASE_URL, payload);
};

export const updateTenantLabourRate = (id: string, data: TenantLabourRatePayload) => {
    const tenantId = data.tenantId || getTenantId();
    if (!tenantId) {
        return Promise.reject(new Error("Organization ID is required"));
    }
    const payload = { ...data, tenantId };
    return api.put(`${TENANT_LABOUR_RATE_BASE_URL}/${id}`, payload);
};

export const deleteTenantLabourRate = (id: string) => {
    return api.delete(`${TENANT_LABOUR_RATE_BASE_URL}/${id}`);
};
